import { getAuth } from "firebase/auth";

function getApiBaseUrl() {
  const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  const fallback =
    "https://us-central1-houari-boumedienne-schoo-4d4c2.cloudfunctions.net";
  const configured = process.env.REACT_APP_API_BASE_URL || "";
  return String(isLocalhost ? configured || fallback : configured).replace(/\/+$/, "");
}

async function callExerciseApi(path, body) {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error("Please sign in again to continue.");
  }

  const idToken = await user.getIdToken();
  const endpoint = `${getApiBaseUrl()}/api/exercises/${path}`;

  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  });

  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("application/json")
    ? await response.json()
    : { ok: false, error: await response.text() };

  if (!response.ok || !payload.ok) {
    throw new Error(payload.error || "Something went wrong.");
  }

  return payload;
}

export function createExercise(data) {
  return callExerciseApi("create", data);
}

export function updateExercise(data) {
  return callExerciseApi("update", data);
}

export function deleteExercise({ groupId, exerciseId }) {
  return callExerciseApi("delete", { groupId, exerciseId });
}

export function getExercise({ groupId, exerciseId }) {
  return callExerciseApi("get", { groupId, exerciseId });
}

export function sendExerciseAiMessage({ groupId, exerciseId, message }) {
  return callExerciseApi("message", { groupId, exerciseId, message });
}

export function escalateExercise({ groupId, exerciseId }) {
  return callExerciseApi("escalate", { groupId, exerciseId });
}

export function sendReviewMessage({ groupId, exerciseId, message }) {
  return callExerciseApi("review-message", { groupId, exerciseId, message });
}

export function regenerateRender({ groupId, exerciseId }) {
  return callExerciseApi("regenerate-render", { groupId, exerciseId });
}

export function validateExercise({ groupId, exerciseId }) {
  return callExerciseApi("validate", { groupId, exerciseId });
}

export function submitHandwrittenAnswer({ groupId, exerciseId, images, voiceTranscript }) {
  return callExerciseApi("submit-answer", {
    groupId,
    exerciseId,
    images,
    voiceTranscript,
  });
}

export function transcribeVoice({ groupId, audioBase64, audioMimeType }) {
  return callExerciseApi("transcribe-voice", {
    groupId,
    audioBase64,
    audioMimeType,
  });
}

export function resubmitAnswerWithCorrection({
  groupId,
  exerciseId,
  submissionMessageId,
  correctedTranscript,
}) {
  return callExerciseApi("resubmit-with-correction", {
    groupId,
    exerciseId,
    submissionMessageId,
    correctedTranscript,
  });
}
